// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentDeactivateResponse {
    static getAttributeTypeMap() {
        return EnrollmentDeactivateResponse.attributeTypeMap;
    }
}
EnrollmentDeactivateResponse.discriminator = undefined;
EnrollmentDeactivateResponse.additionalProperties = false;
EnrollmentDeactivateResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
];
//# sourceMappingURL=enrollmentDeactivateResponse.js.map